import { render, staticRenderFns } from "./DoplnujiciInformace.vue?vue&type=template&id=6a30166c&"
import script from "./DoplnujiciInformace.vue?vue&type=script&lang=ts&"
export * from "./DoplnujiciInformace.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports